import React from "react";

const InfoBox = ({ isTop, children, renderHead }) =>
  isTop ? (
    <div className="infoBox bottom">
      <div className="head">{renderHead()}</div>
      <div className="body">{children}</div>
    </div>
  ) : (
    <div className="infoBox top">
      <div className="body">{children}</div>
      <div className="head">{renderHead()}</div>
    </div>
  );

export default InfoBox;
